import { languages } from "./languages.ts";

/**
 * Locales the whole app is translated into: the ones physicians, the medical
 * team and admins work in.
 */
export const clinicalLocales = ["en", "de", "it", "pl", "sk"];

/**
 * Locales the pre-login pages (login, password reset, MFA) are translated
 * into, since any user may land on them: every language the API supports. In
 * a non-clinical locale, the rest of the app shows in English.
 */
export const supportedLocales: string[] = languages.map(
  (language) => language.code,
);
